import React from 'react';
import { useAtom } from 'jotai';
import { css } from '@linaria/core';
import useTranslation from 'next-translate/useTranslation';
import { ButtonGroup, Radio, RadioGroup } from '@spaceshipapp/cambridge';
import Button from '../../components/Button';
import { typeAtom } from '../../contexts/shipment';
import { ShipmentType } from '../../types/common';

const ShipmentTypePicker: React.FC = () => {
  const { t } = useTranslation('common');
  const [type, setType] = useAtom(typeAtom);

  const handleClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target.value as ShipmentType;
    setType(target);
  };

  return (
    <RadioGroup value={type} onChange={handleClick}>
      <ButtonGroup size="sm">
        <Button
          as={Radio}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          type="radio"
          variant={type === ShipmentType.DOCUMENT ? `primary` : `default`}
          className={btnStyle}
          name="type"
          value={ShipmentType.DOCUMENT}
          data-tracking-label={t('commonEn:Parcel.typeEnvelope')}
        >
          {t('Parcel.typeEnvelope')}
        </Button>
        <Button
          as={Radio}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          type="radio"
          variant={type === ShipmentType.PARCEL ? `primary` : `default`}
          className={btnStyle}
          name="type"
          value={ShipmentType.PARCEL}
          data-tracking-label={t('commonEn:Parcel.typeSmallBox')}
        >
          {t('Parcel.typeSmallBox')}
        </Button>
      </ButtonGroup>
    </RadioGroup>
  );
};

const btnStyle = css`
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;

  > span {
    /* hide fake radio */
    display: none;
  }
`;

export default ShipmentTypePicker;
